//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import messageBox from '@/components/messageBox';
import DataFilter from '@/components/data-filter';
import { VIEW_DATA_TYPE, VIEW_JOB_TYPE, VIEW_ORG_TYPE } from '@/utils/constant';
import { mapGetters } from 'vuex';

const objectActionSimpleOptions = [
  { label: '查询', value: 'select' },
  { label: '新增', value: 'insert' },
  { label: '更新', value: 'update' },
  { label: '删除', value: 'delete' },
];
const initForm = {
  role_id: 0,
  table_code: '',
  object_id: 0,
  view_data_type: '',
  view_job_type: '',
  view_org_type: '',
  view_user_type: 2,
  data_filter_desc: '',
  data_filter: [
    {
      action: ['select', 'create', 'update', 'delete'],
      connector: 'AND',
      conditions: [],
    },
  ],
};

export default {
  name: 'OverviewInit',
  components: { messageBox, DataFilter },
  filters: {
    getFilterTabName: (action, index) => {
      if (!action || action.length === 0) {
        return `Filter${String(index + 1)}`;
      }
      const actionLabelArr = [];
      objectActionSimpleOptions.forEach((v) => {
        if (action.includes(v.value)) {
          actionLabelArr.push(v.label);
        }
      });
      return actionLabelArr.join(' / ');
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      required: true,
      default: null,
    },
    fieldList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      VIEW_DATA_TYPE,
      VIEW_JOB_TYPE,
      VIEW_ORG_TYPE,
      objectActionSimpleOptions,
      form: { ...initForm },
      rules: {
        data_filter_desc: [
          {
            validator: (rule, value, callback) => {
              if (this.haveFilter(this.form.data_filter)) {
                if (!value) {
                  callback(new Error('请输入自定义filter描述'));
                  return;
                }
              }
              callback();
            },
            trigger: 'blur',
          },
        ],
        view_type: [
          {
            validator: (_, __, callback) => {
              if (
                !this.form.view_data_type &&
                !this.form.view_job_type &&
                !this.form.view_org_type
              ) {
                callback(new Error('请选择数据可见范围'));
                return;
              }
              callback();
            },
          },
        ],
      },
      dataPermissionFields: [],
      filterTabsValue: '0',
      searchObj: {
        role_id: Number(this.$route.query.role_id) || 0,
        appid: Number(this.$route.query.appid) || 0,
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        roleManage: this.getElementList.includes('role-manage'),
      };
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.form = { ...this.row };
        this.form.role_id = this.searchObj.role_id || 0;
        this.filterTabsValue = '0';
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
  },
  methods: {
    handleFilterTabsEdit(targetName, action) {
      const currentIndex = Number(this.filterTabsValue);
      if (action === 'add') {
        if (this.form.data_filter.length === 4) {
          this.$message({
            message: 'filter配置最多不超过四条',
            type: 'warning',
          });
          return;
        }

        this.form.data_filter.push({
          action: [],
          connector: 'AND',
          conditions: [],
        });
        this.filterTabsValue = String(this.form.data_filter.length - 1);
      }
      if (action === 'remove') {
        if (this.form.data_filter.length === 1) {
          this.$message({
            message: 'filter配置最少需要一条',
            type: 'warning',
          });
          return;
        }
        if (this.filterTabsValue === targetName) {
          this.form.data_filter.forEach((tab, index) => {
            if (index === Number(targetName)) {
              if (!this.form.data_filter[index + 1]) {
                this.filterTabsValue = String(currentIndex - 1);
              }
            }
          });
        }
        this.form.data_filter.splice(targetName, 1);
      }
    },
    haveFilter(dataFilter) {
      if (dataFilter) {
        if (dataFilter?.length > 0) {
          for (let index = 0; index < dataFilter.length; index++) {
            const item = dataFilter[index];
            if (item.conditions?.length > 0) {
              return true;
            }
          }
          return false;
        }
        // 兼容老数据（对象形式）
        return dataFilter.conditions?.length > 0;
      }
      return false;
    },
    isFilterActionDisabled(curAction) {
      const curIndex = Number(this.filterTabsValue);
      for (let k = 0; k < this.form.data_filter.length; k++) {
        const v = this.form.data_filter[k];
        if (k !== curIndex && v.action.includes(curAction)) {
          return true;
        }
      }
      return false;
    },
    submitDataPermissionForm() {
      for (let index = 0; index < this.form.data_filter.length; index += 1) {
        const item = this.form.data_filter[index];
        if (item.action.length === 0) {
          this.$message({
            message: '不允许有空类型的filter配置',
            type: 'warning',
          });
          return;
        }
      }
      this.$refs.form.validate((val) => {
        if (!val) {
          return;
        }
        const filerValidList = [];
        this.$refs.filter.forEach((v) => {
          filerValidList.push(
            new Promise(function (resolve, reject) {
              v.validate((valid) => {
                if (valid) {
                  resolve();
                } else {
                  reject();
                }
              });
            }),
          );
        });
        Promise.all(filerValidList).then(() => {
          const url = this.$api.setRoleObjectView;
          const cb = () => {
            this.$message({
              message: '对象数据权限设置成功',
              type: 'success',
            });
            this.$emit('success');
          };
          this.$request({
            url,
            cb,
            data: {
              role_id: this.form.role_id,
              object_id: this.form.object_id,
              view_data_type: this.form.view_data_type || 0,
              view_job_type: this.form.view_job_type || 0,
              view_org_type: this.form.view_org_type || 0,
              view_user_type: this.form.view_user_type,
              data_filter_desc: this.form.data_filter_desc,
              data_filter: this.form.data_filter,
            },
          });
        });
      });
    },
    close() {
      this.$refs.messageBox.show({
        title: '放弃编辑后，本次编辑内容将会丢失，确认放弃？',
        titleIconType: 'warning',
        needCancel: true,
        cancelText: '取消',
        confirmType: 'primary',
        confirmAction: () => {
          this.$refs.messageBox.close();
          this.$emit('close');
        },
      });
    },
  },
};
